// Sizes

export enum SEU_DIALOG_SIZE {
  S = '34rem',
  M = '46rem',
}

export enum SEU_DIALOG_MAX_SIZE {
  M = '94vw',
}

// Form Save Dialog

export type SeuFormCancelDialogInput = null;

export type SeuFormCancelDialogOutput = {
  action: 'save' | 'discard';
};

export type SeuFormCancelDialogType = 'discard' | 'cancel';

// Confirm Remove Dialog

export type SeuConfirmRemoveDialogInput = {
  labelKey:
    | 'default'
    | 'offer'
    | 'global-parameter'
    | 'operating-condition'
    | 'component'
    | 'rezirculation'
    | 'interconnection';
};

export type SeuActiveEditorErrorDialogInput = {
  header: string;
  text: string;
};

export type SeuConfirmRemoveDialogOutput = {
  action: 'remove' | 'cancel';
};

// Create Offer Dialog

export type SeuCreateOfferDialogInput = null;

export type SeuCreateOfferDialogOutput =
  | {
      action: 'created';
      offerId: string;
    }
  | {
      action: 'cancel';
    };

// Reset Calculation Dialog

export type SeuResetCalculationDialogInput = null;

export type SeuResetCalculationDialogOutput = {
  action: 'accept' | 'cancel';
};

// Changelog Dialog

export type SeuChangelogDialogInput = {
  offerId: string;
  title: string;
};

export type SeuChangelogDialogOutput = null;
